const ProjectContainer = (props  ) => {
    return(
            <div className=" min-w-full h-screen flex flex-col justify-between  bg-gradient-to-b from-greenThree to-yellow4"> {props.children}</div>
    )
}
export default ProjectContainer;